import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";
// Image
import footerLogo from "../../../assets/img/logo/lite-logo.png";

import QuickLinks from "../../../components/Common/QuickLinks";
import { BlocksRenderer } from "../../../components/BlockRenderer";
import { fetchData } from "../../../utils/fetchData";
import {
  getAPIPath,
  getMenu,
  getPageTitle,
} from "../../../utils/getDomainData";
const ResearchPublications = () => {
  const [boookChapter, setBoookChapter] = useState([]);
  const [InternationalJournal, setInternationalJournal] = useState([]);
  const [InternationalConference, setInternationalConference] = useState([]);
  const [NationalJournal, setNationalJournal] = useState([]);
  const [NationalConference, setNationalConference] = useState([]);
  useEffect(() => {
    fetchData(
      getAPIPath()?.Research_Publications_Boook_Chapter,
      setBoookChapter
    );
    fetchData(
      getAPIPath()?.Research_Publications_Journal_Conference +
        ` &filters[PublicationType][$contains]=International Journal`,
      setInternationalJournal
    );
    fetchData(
      getAPIPath()?.Research_Publications_Journal_Conference +
        ` &filters[PublicationType][$contains]=International Conference`,
      setInternationalConference
    );
    fetchData(
      getAPIPath()?.Research_Publications_Journal_Conference +
        ` &filters[PublicationType][$contains]=National Journal`,
      setNationalJournal
    );
    fetchData(
      getAPIPath()?.Research_Publications_Journal_Conference +
        ` &filters[PublicationType][$contains]=National Conference`,
      setNationalConference
    );
  }, []);
  return (
    <React.Fragment>
      <Helmet>
        <title>Research Publications – {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Research Publications"
          pageName="Research Publications"
          breadcrumbsClass="breadcrumb-bg"
        />
        {getMenu()}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col-lg-9 md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <h3 style={{ marginBottom: "20px" }} title="Research Publications">
                      Research Publications
                    </h3>
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col"> Book Chapter</th>
                        </tr>
                      </thead>
                      <tbody>
                        {boookChapter?.data?.map((obj, index) => (
                          <tr>
                            <td>{index + 1}.</td>
                            <td>
                              <BlocksRenderer
                                content={obj?.attributes?.BookChapter}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Journal/Conference Publication</th>
                          <th scope="col">Impact Factor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th colspan={4} style={{ textAlign: "center" }}>
                            International Journal
                          </th>
                        </tr>
                        {InternationalJournal?.data?.map((obj, index) => (
                          <tr>
                            <td>{index + 1}.</td>
                            <td>
                              <BlocksRenderer
                                content={obj?.attributes?.Description}
                              />
                            </td>
                            <td>{obj?.attributes?.ImpactFactor}</td>
                          </tr>
                        ))}
                        <tr>
                          <th colspan={4} style={{ textAlign: "center" }}>
                            International Conference
                          </th>
                        </tr>
                        {InternationalConference?.data?.map((obj, index) => (
                          <tr>
                            <td>{index + 1}.</td>
                            <td>
                              <BlocksRenderer
                                content={obj?.attributes?.Description}
                              />
                            </td>
                            <td>{obj?.attributes?.ImpactFactor}</td>
                          </tr>
                        ))}
                        <tr>
                          <th colspan={4} style={{ textAlign: "center" }}>
                            National Journal
                          </th>
                        </tr>
                        {NationalJournal?.data?.map((obj, index) => (
                          <tr>
                            <td>{index + 1}.</td>
                            <td>
                              <BlocksRenderer
                                content={obj?.attributes?.Description}
                              />
                            </td>
                            <td>{obj?.attributes?.ImpactFactor}</td>
                          </tr>
                        ))}
                        <tr>
                          <th colspan={4} style={{ textAlign: "center" }}>
                            National Conference
                          </th>
                        </tr>
                        {NationalConference?.data?.map((obj, index) => (
                          <tr>
                            <td>{index + 1}.</td>
                            <td>
                              <BlocksRenderer
                                content={obj?.attributes?.Description}
                              />
                            </td>
                            <td>{obj?.attributes?.ImpactFactor}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 pl-20 md-pl-14">
                <div className="about-intro">
                  <QuickLinks />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Accredation /> */}

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup secondaryColor" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default ResearchPublications;
